import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useAuth from 'providers/Auth/useAuth';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { Box, Tab, Tabs } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { IMPORT_TYPE } from 'utils/GlobalVariables';
import ImportData from './ImportData';
import MappingCulture from '../Administration/Tools/Mapping/MappingCulture';
import { tabsTheme } from 'assets/styles/themes/tabs_mui';
import MappingGroundType from '../Administration/Tools/Mapping/MappingGroundType';
import { MappingImportResponseProvider } from 'utils/context';

const CooperativeImport = ({ groundTypes }) => {
  const [value, setValue] = useState(0);
  const [cooperativeId, setCooperativeId] = useState('');
  const [exploitationId, setExploitationId] = useState(null);
  const [mappingTypes, setMappingTypes] = useState(null);
  const [cultureList, setCultureList] = useState(null);
  const [groundTypeList, setGroundTypeList] = useState([]);
  const { user } = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const locationRoute = window.location.pathname.split('/')[1];

  useEffect(() => {
    let coopId = '';
    if (localStorage.getItem('cooperative')) {
      coopId = localStorage.getItem('cooperative');
    } else if (user.cooperative?.id) {
      coopId = user.cooperative.id;
    }

    if (!coopId) {
      toast.info(t('message.selectCooperative'));
      navigate('/cooperative');
    } else {
      setCooperativeId(coopId);
    }

    if (localStorage.getItem('exploitation')) {
      setExploitationId(localStorage.getItem('exploitation'));
    }
  }, [navigate, user]);

  useEffect(() => {
    if (Array.isArray(groundTypes)) {
      setGroundTypeList(
        groundTypes?.map((groundType) => ({
          label: groundType.name,
          value: groundType.id,
        })),
      );
    }
  }, [groundTypes]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  return (
    <div className="section">
      <MappingImportResponseProvider>
        <ThemeProvider theme={tabsTheme}>
          {locationRoute === 'cooperative' ? (
            <Tabs value={value} onChange={handleChange} centered sx={{ paddingTop: '20px' }}>
              <Tab label={t('tab.importData')} {...a11yProps(0)} />
              <Tab label={t('tab.cultureMapping')} {...a11yProps(1)} />
              <Tab label={t('tab.groundTypeMapping')} {...a11yProps(2)} />
            </Tabs>
          ) : (
            <Tabs value={value} onChange={handleChange} centered sx={{ paddingTop: '20px' }}>
              <Tab label={t('tab.importData')} {...a11yProps(0)} sx={{ pointerEvents: 'none' }} />
            </Tabs>
          )}
          <CustomTabPanel value={value} index={0}>
            <ImportData
              mappingTypes={mappingTypes}
              cooperativeId={cooperativeId}
              setMappingTypes={setMappingTypes}
            />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            <MappingCulture
              cultureList={cultureList}
              cooperativeId={cooperativeId}
              mappingTypes={mappingTypes}
              setCultureList={setCultureList}
            />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={2}>
            <MappingGroundType
              groundTypeList={groundTypeList}
              cooperativeId={cooperativeId}
              mappingTypes={mappingTypes?.filter((type) => type !== IMPORT_TYPE.telepac && type !== IMPORT_TYPE.apia)}
            />
          </CustomTabPanel>
        </ThemeProvider>
      </MappingImportResponseProvider>
    </div>
  );
};

export default CooperativeImport;

const CustomTabPanel = (props) => {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
};
